export type FormatParams = Readonly<Record<string, string | number>>;

const PLACEHOLDER = /\{(\w+)\}/g;

export function formatMessage(template: string, params: FormatParams | undefined): string {
  if (params === undefined) return template;
  let result = "";
  let lastIndex = 0;
  for (const match of template.matchAll(PLACEHOLDER)) {
    const name = match[1];
    if (name === undefined) continue;
    result += template.slice(lastIndex, match.index);
    const value = params[name];
    result += value === undefined ? match[0] : String(value);
    lastIndex = match.index + match[0].length;
  }
  result += template.slice(lastIndex);
  return result;
}
